import axios from 'axios';
import React, { useReducer } from 'react';
import { Nullable } from 'types/utilityTypes';
import { initialState, AuthReducer, authActionsType, authStateType } from './reducer';


interface authProviderProps {
    children?: JSX.Element;
};


const AuthStateContext = React.createContext<authStateType>(initialState);
const AuthDispatchContext = React.createContext<React.Dispatch<authStateType> | null>(null);


export const useSystemAuthState = () => {
	const context = React.useContext(AuthStateContext);
	if (context?.token){
	axios.defaults.headers.common[
		"Authorization"
	  ] = `Bearer ${context.token}`;
	}
	if (context === undefined) {
		throw new Error('useAuthState must be used within a AuthProvider');
	}

	return context;
};

export const useSystemAuthDispatch = () => {
	const context = React.useContext(AuthDispatchContext);
	if (context === undefined) {
		throw new Error('useAuthDispatch must be used within a AuthProvider');
	}

	return context;
};

export const SystemAuthProvider = ({ children }:authProviderProps) => {
	const [user, dispatch] = useReducer(AuthReducer, initialState);

	return (
	<AuthStateContext.Provider value={user}>
    <AuthDispatchContext.Provider value={dispatch}>
        {children}
    </AuthDispatchContext.Provider>
</AuthStateContext.Provider>	
	);
};
